import { Component, inject } from '@angular/core';
import { AuthService } from '@core/services/auth.service';

@Component({
    selector: 'app-sidenav',
    templateUrl: './sidenav.component.html',
    standalone: false
})
export class SidenavComponent {
  auth = inject(AuthService);
  showPartners!: boolean;
  showLogs!: boolean;
  showUsers!: boolean;
  showNav = true;

  ngOnInit(){
    this.auth.ready().subscribe(isReady => {
      if(isReady){
        this.showPartners = this.auth.canView('partner');
        this.showUsers = this.auth.canView('user');
        this.showLogs = this.auth.canView('integration-log');
      }
    })
  }
}
